/* eslint no-cond-assign: 0 */
import {
    call,
    put,
    take,
    select
} from 'redux-saga/effects';

import {
    handleUtagEvent
} from '../../../core/js/actions/initialActions';

import {
    initialSaga
} from '../../../core/js/sagas/initialSagas';

import {
    saveWishlistData,
    submitSearchWishlistError,
    WISHLIST_ADD_TO_CART,
    searchWishlistResults
} from '../actions/wishlistActions';

import { UPDATED_CART_ITEM } from '../../../core/js/actions/cartActions';

import {
    addedToCart
} from '../../../product/js/actions/productActions';

import { makeRequest } from '../../../core/js/sagas/makeRequest';
import {
    getWishlistItemsRoute,
    orchestrationDeleteWishlistRoute,
    orchestrationWishlists,
    addToCartRoute,
    orchestrationWishlistsPutRoute,
    createWishlist,
    searchWishlistRoute
} from '../../../core/js/utils/apiRoutes';

import {
    getSelectedPrice,
    getSelectedImageId
} from '../../../product/js/utils/utils';

import { getNavId } from '../../../product/js/utils/cartUtils';

import { error, info } from '../../../core/js/utils/logger';

import {
    initializeRRSaga,
    initializeDynamicYieldSaga
} from '../../../core/js/sagas/recommendationsSagas';

import rrUtils from '../../../core/js/utils/rrUtils';

import { config } from '../../../product/js/configs/config';
import { updateButtonTextSaga } from '../../../core/js/sagas/animateButtonSagas';
import { translate } from '../../../core/js/utils/localizationUtils';

export function* wishlistInitialSaga() {
    yield call(initialSaga);

    const state = yield select();

    let rrPlacementId = null;
    let dyPlacementIds = null;

    if (_.get(state, 'wishlist.content')) {
        const placementData = rrUtils.getRichRelevancePlacementData();
        rrPlacementId = placementData.rrPlacementId;
        dyPlacementIds = placementData.dyPlacementIds;
    }

    if (rrPlacementId) {
        yield call(initializeRRSaga, rrPlacementId);
    }

    if (dyPlacementIds && dyPlacementIds.length > 0) {
        for (const dyPlacementId of dyPlacementIds) {
            yield call(initializeDynamicYieldSaga, dyPlacementId);
        }
    }
}

export function* submitCreateWishlistSaga(payload) {
    info('submitCreateWishlistSaga');

    const state = yield select();

    const params = {
        name: payload,
        visibility: 'SHAREABLE'
    };

    const route = createWishlist(state, params);

    return yield call(makeRequest, route);
}

export function* submitSearchWishlistSagaTry(res) {
    const state = yield select();

    yield put(searchWishlistResults(res));

    const wishlistSuccessData = {
        // eslint-disable-next-line camelcase
        page_id: state.core.localizations.containers.analyticsContainer.wishlist_search_results_page_id,
        // eslint-disable-next-line camelcase
        category_id: state.core.localizations.containers.analyticsContainer.wishlist_search_results_category_id
    };

    yield put(handleUtagEvent(wishlistSuccessData, 'view'));
}

/*
 * Submit a wishlist search.
 * @param {Function} getState - Redux getState
 * @param {Object} payload - Search payload
 * @param {Object} payload.firstName - First name
 * @param {Object} payload.lastName - Last name
 * @param {Object} payload.email - Email address
 * @param {Object} payload.city - Refine the search by city
 * @param {Object} payload.state - Refine the search by state
 */
export function* submitSearchWishlistSaga(payload) {
    const state = yield select();
    const route = searchWishlistRoute(state, payload);

    try {
        const res = yield call(makeRequest, route);

        yield call(submitSearchWishlistSagaTry, res);
    } catch (err) {
        if (err) {
            yield call(submitSearchWishlistSagaTry, {});
        } else {
            error(`Error searching wishlist: ${err}.`);
            yield put(submitSearchWishlistError(err));
        }
    }
}

/**
 * @param {object} payload - Current wishlist id
 * @returns {*} new wishlist call
 */
export function* deleteWishlistSaga(payload) {
    const state = yield select();
    const deleteRoute = orchestrationDeleteWishlistRoute(state, payload);
    const wishlistsRoute = orchestrationWishlists(state);

    const response = yield call(makeRequest, deleteRoute);

    return yield call(makeRequest, wishlistsRoute);
}

export function* editWishlistSaga(payload) {
    const state = yield select();
    const id = state.wishlist.currentWishlist;
    const params = {
        name: payload.name,
        visibility: payload.visibility
    };

    if (payload.addressId !== '') {
        params.addressId = payload.addressId;
    }

    const wishlistPutRoute = orchestrationWishlistsPutRoute(state, id, params);

    return yield call(makeRequest, wishlistPutRoute);
}

/**
 * Update the wishlist items.
 *
 * Normal saga here so that it can be called in synchronously
 *
 * @param {function} getState Redux getState function
 */
export function* updateWishlistItemsSaga() {
    const state = yield select();

    if (!_.get(state, 'wishlist.currentWishlist')) {
        return;
    }

    const page = _.get(state, 'wishlist.pagination.page');

    // Refetch the current wishlist data
    const getWishlistDataRoute = getWishlistItemsRoute(state, state.wishlist.currentWishlist, page);

    try {
        const data = yield call(makeRequest, getWishlistDataRoute);

        yield put(saveWishlistData(data));
    } catch (err) {
        error(`Error retrieving updated wishlist: ${err}`);
    }
}

/**
 * Update the wishlist items when a UPDATED_CART_ITEM is dispatched elsewhere in
 *  the system
 *
 * @param {function} getState Redux getState function
 */
export function* updateWishlistItemsFromCartUpdateSaga() {
    let payload = {};

    while ({ payload } = yield take(UPDATED_CART_ITEM)) {
        yield call(updateWishlistItemsSaga);
    }
}

export function* addToCartWishlistSaga() {
    let payload = {};

    while ({ payload } = yield take(WISHLIST_ADD_TO_CART)) {
        const state = yield select();
        const navigationId = getNavId(state);
        const salesAttributes = _.get(payload, 'item.salesAttributes', '');

        let currentWishlistId = null;

        if (typeof state !== 'undefined' && typeof state.wishlist !== 'undefined'
            && typeof state.wishlist.currentWishlist !== 'undefined') {
            currentWishlistId = state.wishlist.currentWishlist;
        }

        const params = {
            skuId: payload.skuData.skuId,
            poolId: payload.skuData.pool,
            quantity: payload.item.quantity,
            productId: payload.skuData.productId,
            wishlist: {
                id: currentWishlistId
            },
            analytics: {
                navigationId: navigationId
            }
        };

        if (salesAttributes) {
            params.salesAttributes = salesAttributes;
        }

        const route = addToCartRoute(state, params);

        try {
            const addOptions = {
                changeToText: translate(state, 'product_added-to-cart'),
                changeBackText: translate(state, 'product_add-to-cart')
            };
            const addToCartSagaCall = call(makeRequest, route);
            const addToCartResponse = yield call(updateButtonTextSaga, addToCartSagaCall,
                payload.itemSelector, config.addToCart.resetDelay, addOptions);
            const imageStyle = payload.item.catalogInfo.product.supplierSku ?
                payload.item.catalogInfo.product.supplierSku : payload.item.catalogInfo.product.styleNumber;
            const confirmOptions = {
                showConfirm: true,
                confirmViewModel: {
                    colorCode: payload.skuData.colorId,
                    colorName: payload.skuData.color,
                    displayName: payload.item.catalogInfo.product.displayName,
                    imageId: getSelectedImageId(payload.item.catalogInfo.skuInfo.primarySlice.sliceItems[0]),
                    longDescription: payload.item.catalogInfo.product.longDescription,
                    price: getSelectedPrice(payload.skuData, payload.item.catalogInfo.skuInfo),
                    'size': payload.skuData.size,
                    styleNumber: payload.item.catalogInfo.product.styleNumber,
                    imageStyle: imageStyle,
                    quantity: addToCartResponse.quantityRequested,
                    primaryLabel: payload.item.catalogInfo.skuInfo.primarySlice.displayLabel,
                    secondaryLabel: payload.item.catalogInfo.skuInfo.secondarySlice.displayLabel
                },
                isConfirmTimerActive: true,
                quantityRequested: addToCartResponse.quantityRequested
            };
            const pwaEvent = new CustomEvent('a15-item-added-to-cart', {
                detail: _.cloneDeep(confirmOptions.confirmViewModel)
            });

            yield put(addedToCart(confirmOptions));
            document.dispatchEvent(pwaEvent);
        } catch (err) {
            error(`Error obtaining product response: ${err}`);
        }
    }
}

export default [
    wishlistInitialSaga,
    updateWishlistItemsFromCartUpdateSaga,
    addToCartWishlistSaga
];
